import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import TermsPolicyPage from './pages/TermsPolicy';
import ProxyPage from './pages/ProxyPage';
import { startAutoRefresh, stopAutoRefresh } from './services/api';
import { TelegramModalProvider } from './context/TelegramModalContext';
import TelegramModal from './components/TelegramModal';
import { useDevicePixelSnappedTokens } from './hooks/useDevicePixelSnappedTokens';

function App() {
  useDevicePixelSnappedTokens();

  useEffect(() => {
    // Запускаем автообновление кэша при загрузке приложения
    startAutoRefresh();

    // Останавливаем автообновление при размонтировании
    return () => {
      stopAutoRefresh();
    };
  }, []);

  useEffect(() => {
    const root = document.documentElement;

    const setInputModality = (modality) => {
      if (root.dataset.inputModality !== modality) {
        root.dataset.inputModality = modality;
      }
    };

    const finePointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
    setInputModality(finePointerQuery.matches ? 'fine' : 'touch');

    const handlePointerDown = (event) => {
      setInputModality(event.pointerType === 'mouse' ? 'fine' : 'touch');
    };

    const handleMouseMove = () => {
      setInputModality('fine');
    };

    const handleTouchStart = () => {
      setInputModality('touch');
    };

    window.addEventListener('pointerdown', handlePointerDown, true);
    window.addEventListener('mousemove', handleMouseMove, { passive: true, capture: true });
    window.addEventListener('touchstart', handleTouchStart, { passive: true, capture: true });

    return () => {
      window.removeEventListener('pointerdown', handlePointerDown, true);
      window.removeEventListener('mousemove', handleMouseMove, true);
      window.removeEventListener('touchstart', handleTouchStart, true);
    };
  }, []);

  return (
    <TelegramModalProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terms-policy" element={<TermsPolicyPage />} />
          <Route path="/proxy" element={<ProxyPage />} />
          <Route path="/terms" element={<Navigate to="/terms-policy" replace />} />
        </Routes>
        <TelegramModal />
      </Router>
    </TelegramModalProvider>
  );
}

export default App;
